import { Loader } from '@googlemaps/js-api-loader';
import selectize from '@selectize/selectize'

export default class DevelopmentsListings {
    constructor() {
        this.listLink = document.querySelector('.js-developments-toggle-list');
        this.mapLink = document.querySelector('.js-developments-toggle-map');
        this.map = document.querySelector('.js-developments-map');
        this.list = document.querySelector('.js-developments-list');
        this.select = document.querySelector('.js-developments-select');
        this.selectEl = false;
        this.markers = [];

        if (this.map) {
            this.init();
        }
    }

    init() {

        if (this.select) {
            this.selectEl = $(this.select).selectize();
        }

        this.listLink.addEventListener("click", (e) => {
            this.displayList();
        });
        this.listLink.addEventListener("keydown", (e) => {
            e.preventDefault();
            if (e.code === "Enter") {
                this.displayList();
            }
        });

        this.mapLink.addEventListener("click", (e) => {
            this.displayMap();
        });
        this.mapLink.addEventListener("keydown", (e) => {
            e.preventDefault();
            if (e.code === "Enter") {
                this.displayMap();
            }
        });
        
        this.selectEl.on('change', (e) => {
            let selected = this.selectEl[0].selectize.getValue();
            window.location.href = `/developments/${selected}`;
        });

        // this.select.addEventListener('change', (e) => {
        //     let selected = e.target.value;
        //     let activeCard = 'all';

        //     window.location.href = `/developments/${selected}`;

        //     if (selected != " ") {
        //         activeCard = selected;
        //     }
            
        //     document.querySelectorAll('.developments__card').forEach(element => {
        //         if (activeCard == 'all' || activeCard == element.dataset.development) {
        //             element.classList.add('developments__card--active');
        //         } else {
        //             element.classList.remove('developments__card--active');
        //         }
        //     });

        //     this.toggleMapMarkers(selected);
        // });
        
        
        const loader = new Loader({
            apiKey: "AIzaSyAARJek3g15lsV7j1EgTxwTkRNbksu5UEQ",
            version: "weekly",
            libraries: ["places"]
        });

        const mapOptions = {
            center: {
                lat: -25.344,
                lng: 131.031
            },
            zoom: 4
        };

        // Callback
        loader.loadCallback(e => {
            if (e) {
                console.log(e);
            } else {

                let bounds = new google.maps.LatLngBounds();
                const map = new google.maps.Map(document.getElementById("map"), mapOptions);

                let pins = JSON.parse(this.map.dataset.pins);

                pins.forEach(pin => {
                    if (pin.lat || pin.lng) {                        
                        
                        const infowindow = new google.maps.InfoWindow({
                            content: `<h2>${pin.title}</h2>`,
                            ariaLabel: pin.title,
                        });

                        const marker = new google.maps.Marker({
                            position: { lat: pin.lat, lng: pin.lng },
                            icon: "/app/themes/fabric/dist/images/pin.svg",
                            map: map,
                            title: pin.title,
                            slug: pin.slug
                        });

                        marker.addListener("click", () => {
                            infowindow.open({
                              anchor: marker,
                              map,
                            });
                        });

                        bounds.extend(marker.position);
                        this.markers.push(marker);
                    }
                });

                map.fitBounds(bounds);

                var listener = google.maps.event.addListener(map, "idle", function () {
                    map.setZoom(7);
                    google.maps.event.removeListener(listener);
                });

            }
        });

    }
    displayList() {
        this.mapLink.classList.remove('developments__toggle--active');
        this.map.classList.remove('developments__listings--active');

        this.listLink.classList.add('developments__toggle--active');
        this.list.classList.add('developments__listings--active');
    }
    displayMap() {
        this.listLink.classList.remove('developments__toggle--active');
        this.list.classList.remove('developments__listings--active');

        this.mapLink.classList.add('developments__toggle--active');
        this.map.classList.add('developments__listings--active');
    }

    toggleMapMarkers(currentDevelopment) {
        let visbility = true;

        this.markers.forEach(marker => {
            if (currentDevelopment != " ") {
                visbility = marker.slug == currentDevelopment ? true : false;
            }
            marker.setVisible(visbility);
        });
    }
}
